/*
 *
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './health-camp-participant.reducer';

export const HealthCampParticipantDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const healthCampParticipantEntity = useAppSelector(state => state.healthCampParticipant.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="healthCampParticipantDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.healthCampParticipant.detail.title">HealthCampParticipant</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.healthCampParticipant.id">Id</Translate>
            </span>
          </dt>
          <dd>{healthCampParticipantEntity.id}</dd>
          <dt>
            <span id="participantId">
              <Translate contentKey="tinyMedicRestApp.healthCampParticipant.participantId">Participant Id</Translate>
            </span>
          </dt>
          <dd>{healthCampParticipantEntity.participantId}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.healthCampParticipant.active">Active</Translate>
            </span>
          </dt>
          <dd>{healthCampParticipantEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.healthCampParticipant.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{healthCampParticipantEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.healthCampParticipant.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{healthCampParticipantEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.healthCampParticipant.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{healthCampParticipantEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.healthCampParticipant.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{healthCampParticipantEntity.timestampEntry}</dd>
          <dt>
            <span id="attended">
              <Translate contentKey="tinyMedicRestApp.healthCampParticipant.attended">Attended</Translate>
            </span>
          </dt>
          <dd>{healthCampParticipantEntity.attended ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.healthCampParticipant.role">Role</Translate>
          </dt>
          <dd>{healthCampParticipantEntity.role ? healthCampParticipantEntity.role.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.healthCampParticipant.camp">Camp</Translate>
          </dt>
          <dd>{healthCampParticipantEntity.camp ? healthCampParticipantEntity.camp.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/health-camp-participant" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/health-camp-participant/${healthCampParticipantEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default HealthCampParticipantDetail;
